import { render, staticRenderFns } from "./FundingAssessmentsRecipientsModal.vue?vue&type=template&id=23df5c76&"
import script from "./FundingAssessmentsRecipientsModal.vue?vue&type=script&lang=js&"
export * from "./FundingAssessmentsRecipientsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports